import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type {
  CreateReviewRequest,
  CreateReviewResponse,
  GetReviewDataRequest,
  GetReviewDataResponse,
  SaveUserResponseForReviewRequest,
  SaveUserResponseForReviewResponse,
  UserPermissionsToMarkReviewRequest,
  UserPermissionsToMarkReviewResponse,
  SendNotificationForReviewRequest,
  SendNotificationForReviewResponse,
  FetchListOfStatusesAvailableRequest,
  FetchListOfStatusesAvailableResponse,
  FetchBulkTransitionStatusListRequest,
  FetchBulkTransitionStatusListResponse,
  ChangeResourceStatusInReviewRequest,
  ChangeResourceStatusInReviewResponse,
  NotifyUsersInLevelRequest,
  NotifyUsersInLevelResponse,
  NotifyUserInReviewRequest,
  NotifyUserInReviewResponse,
  GetFileStatusInAllReviewsRequest,
  GetFileStatusInAllReviewsResponse,
  GetReviewStatusForAllFileVersionsRequest,
  GetReviewStatusForAllFileVersionsResponse,
  InitiateReviewRequest,
  InitiateReviewResponse,
  AddResourcesToReviewRequest,
  AddResourcesToReviewResponse,
  RemoveResourcesFromReviewRequest,
  RemoveResourcesFromReviewResponse,
  RollbackReviewRequest,
  RollbackReviewResponse,
  GetReviewsListForEntityRequest,
  GetReviewsListForEntityResponse,
  CanUserClearReviewLevelRequest,
  CanUserClearReviewLevelResponse,
  UpdateFilesInReviewRequest,
  UpdateFilesInReviewResponse,
  GetResourcesInReviewRequest,
  GetResourcesInReviewResponse,
  GetIssuesDetailsInReviewRequest,
  GetIssuesDetailsInReviewResponse,
  AddSignatureToResourcesRequest,
  AddSignatureToResourcesResponse,
  AddReferencedFilesInReviewsRequest,
  AddReferencedFilesInReviewsResponse,
  UpdateReviewStatusRequest,
  UpdateReviewStatusResponse,
  ChecklistsInReviewsRequest,
  ChecklistsInReviewsResponse,
  GetChecklistQuestionCommentsRequest,
  GetChecklistQuestionCommentsResponse,
  GetChecklistQuestionHistoryRequest,
  GetChecklistQuestionHistoryResponse,
  ManageChecklistRequest,
  ManageChecklistResponse,
} from "@ServerTypes/reviews/reviews.schema.js";

export const createReviewRequest = (data: CreateReviewRequest) =>
  axiosWrapper.post<CreateReviewResponse>(`${getBackendUrl()}/reviews/createReview`, data);

export const getReviewDataRequest = (data: GetReviewDataRequest) =>
  axiosWrapper.post<GetReviewDataResponse>(`${getBackendUrl()}/reviews/getReviewData`, data);

export const saveUserResponseForReviewRequest = (data: SaveUserResponseForReviewRequest) =>
  axiosWrapper.post<SaveUserResponseForReviewResponse>(`${getBackendUrl()}/reviews/saveUserResponseForReview`, data);

export const userPermissionsToMarkReviewRequest = (data: UserPermissionsToMarkReviewRequest) =>
  axiosWrapper.post<UserPermissionsToMarkReviewResponse>(
    `${getBackendUrl()}/reviews/userPermissionsToMarkReview`,
    data,
  );

export const sendNotificationForReviewRequest = (data: SendNotificationForReviewRequest) =>
  axiosWrapper.post<SendNotificationForReviewResponse>(`${getBackendUrl()}/reviews/sendNotificationForReview`, data);

export const fetchListOfStatusesAvailableRequest = (data: FetchListOfStatusesAvailableRequest) =>
  axiosWrapper.post<FetchListOfStatusesAvailableResponse>(
    `${getBackendUrl()}/reviews/fetchListOfStatusesAvailable`,
    data,
  );

export const fetchBulkTransitionStatusListRequest = (data: FetchBulkTransitionStatusListRequest) =>
  axiosWrapper.post<FetchBulkTransitionStatusListResponse>(
    `${getBackendUrl()}/reviews/fetchBulkTransitionStatusList`,
    data,
  );

export const changeResourceStatusInReviewRequest = (data: ChangeResourceStatusInReviewRequest) =>
  axiosWrapper.post<ChangeResourceStatusInReviewResponse>(
    `${getBackendUrl()}/reviews/changeResourceStatusInReview`,
    data,
  );

export const notifyUsersInLevelRequest = (data: NotifyUsersInLevelRequest) =>
  axiosWrapper.post<NotifyUsersInLevelResponse>(`${getBackendUrl()}/reviews/notifyUsersInLevel`, data);

export const notifyUserInReviewRequest = (data: NotifyUserInReviewRequest) =>
  axiosWrapper.post<NotifyUserInReviewResponse>(`${getBackendUrl()}/reviews/notifyUserInReview`, data);

export const getFileStatusInAllReviewsRequest = (data: GetFileStatusInAllReviewsRequest) =>
  axiosWrapper.post<GetFileStatusInAllReviewsResponse>(`${getBackendUrl()}/reviews/getFileStatusInAllReviews`, data);

export const getReviewStatusForAllFileVersionsRequest = (data: GetReviewStatusForAllFileVersionsRequest) =>
  axiosWrapper.post<GetReviewStatusForAllFileVersionsResponse>(
    `${getBackendUrl()}/reviews/getReviewStatusForAllFileVersions`,
    data,
  );

export const initiateReviewRequest = (data: InitiateReviewRequest) =>
  axiosWrapper.post<InitiateReviewResponse>(`${getBackendUrl()}/reviews/initiateReview`, data);

export const addResourcesToReviewRequest = (data: AddResourcesToReviewRequest) =>
  axiosWrapper.post<AddResourcesToReviewResponse>(`${getBackendUrl()}/reviews/addResourcesToReview`, data);

export const removeResourcesFromReviewRequest = (data: RemoveResourcesFromReviewRequest) =>
  axiosWrapper.post<RemoveResourcesFromReviewResponse>(`${getBackendUrl()}/reviews/removeResourcesFromReview`, data);

export const rollbackReviewRequest = (data: RollbackReviewRequest) =>
  axiosWrapper.post<RollbackReviewResponse>(`${getBackendUrl()}/reviews/rollbackReview`, data);

export const getReviewsListForEntityRequest = (data: GetReviewsListForEntityRequest) =>
  axiosWrapper.post<GetReviewsListForEntityResponse>(`${getBackendUrl()}/reviews/getReviewsListForEntity`, data);

export const canUserClearReviewLevelRequest = (data: CanUserClearReviewLevelRequest) =>
  axiosWrapper.post<CanUserClearReviewLevelResponse>(`${getBackendUrl()}/reviews/canUserClearReviewLevel`, data);

export const updateFilesInReviewRequest = (data: UpdateFilesInReviewRequest) =>
  axiosWrapper.post<UpdateFilesInReviewResponse>(`${getBackendUrl()}/reviews/updateFilesInReview`, data);

export const getResourcesInReviewRequest = (data: GetResourcesInReviewRequest) =>
  axiosWrapper.post<GetResourcesInReviewResponse>(`${getBackendUrl()}/reviews/getResourcesInReviewService`, data);

export const getIssuesDetailsInReviewRequest = (data: GetIssuesDetailsInReviewRequest) =>
  axiosWrapper.post<GetIssuesDetailsInReviewResponse>(
    `${getBackendUrl()}/reviews/getIssuesDetailsInReviewService`,
    data,
  );

export const addSignatureToResourcesRequest = (data: AddSignatureToResourcesRequest) =>
  axiosWrapper.post<AddSignatureToResourcesResponse>(`${getBackendUrl()}/reviews/addSignatureToResources`, data);

export const referencedFilesInReviewsRequest = (
  data: AddReferencedFilesInReviewsRequest & { action?: "update" | "delete" },
) => {
  // Dispatch to the dedicated endpoints (split from the old action-dispatched /referencedFilesInReviews).
  const path =
    data.action === "delete" ? "/reviews/deleteReferencedFilesInReviews" : "/reviews/updateReferencedFilesInReviews";
  return axiosWrapper.post<AddReferencedFilesInReviewsResponse>(`${getBackendUrl()}${path}`, data);
};

export const updateReviewStatusRequest = (data: UpdateReviewStatusRequest) =>
  axiosWrapper.post<UpdateReviewStatusResponse>(`${getBackendUrl()}/reviews/updateReviewStatus`, data);

export const checklistsInReviewsRequest = (data: ChecklistsInReviewsRequest) =>
  axiosWrapper.post<ChecklistsInReviewsResponse>(`${getBackendUrl()}/reviews/checklistsInReviews`, data);

export const getChecklistQuestionCommentsRequest = (data: GetChecklistQuestionCommentsRequest) =>
  axiosWrapper.post<GetChecklistQuestionCommentsResponse>(
    `${getBackendUrl()}/reviews/getChecklistQuestionComments`,
    data,
  );

export const getChecklistQuestionHistoryRequest = (data: GetChecklistQuestionHistoryRequest) =>
  axiosWrapper.post<GetChecklistQuestionHistoryResponse>(
    `${getBackendUrl()}/reviews/getChecklistQuestionHistory`,
    data,
  );

export const manageChecklistRequest = (data: ManageChecklistRequest) =>
  axiosWrapper.post<ManageChecklistResponse>(`${getBackendUrl()}/reviews/manageChecklist`, data);
